import { Component, Inject, Input, OnInit } from '@angular/core';
import { AreasModel, ObjetivosAreaJardinModel, SubdimensionModel } from 'src/app/model/FaseEstrategica.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';
import Swal from 'sweetalert2';
import { FaseEstrategicaComponent } from '../fase-estrategica.component';

@Component({
  selector: 'app-area-fe',
  templateUrl: './area-fe.component.html',
  styleUrls: ['./area-fe.component.css']
})
export class AreaFEComponent implements OnInit {

  @Input() areaData : AreasModel;
  @Input() estadoData : number;
  @Input() dataJardin : JardinModel;
  @Input() simulacion: boolean;

  cargando: boolean;

  //objetivosAreas = new Array<ObjetivosAreaJardinModel>();
  subdimensiones = new Array<SubdimensionModel>();

  public isCollapsed = true;

  constructor(
    @Inject(FaseEstrategicaComponent) private parentFE: FaseEstrategicaComponent,
    private api: apiService,
    private planMejoraService: PlanMejoraService
    ) { }

  ngOnInit(): void {
   // this.objetivosAreas = this.areaData.objetivosAreas;
    this.subdimensiones = this.areaData.subdimensiones;
    this.cargaInicial();
  }

  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
  }

  addNuevoObjetivo(objetivosAreas): void {
    objetivosAreas.push(new ObjetivosAreaJardinModel());
  }

  borrarObjetivo(objetivosAreas): void {
      Swal.fire({
        title: '¿Está seguro que desea borrar el Objetivo?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          if (objetivosAreas.length == 2 && (objetivosAreas[objetivosAreas.length-1].idObjetivo !=-1 && objetivosAreas[objetivosAreas.length-1].idObjetivo !=null)) {
            this.borrarObjetivoBD(objetivosAreas.pop());
          } else {
            objetivosAreas.pop();
          }
          Swal.fire({
            title: 'Objetivo borrado!',
            icon: 'info',
            confirmButtonText: 'OK'
          })
        }
      });
  }

  borrarObjetivoBD( objetivo : ObjetivosAreaJardinModel){
    this.planMejoraService.API_POST_borrarObjetivoFaseEstrategica(this.dataJardin.id,objetivo.idObjetivo).subscribe((response:any) => {
    },
    (err) => {
      console.log(err)
    });
  }
}
